import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import Navbar from './NavbarStory';
import { useLocation, useNavigate } from 'react-router-dom';
import Calling from '../../api/Calling';
import { imageType, videoType, MAX_FILE_SIZE_IMAGE, videoSizeExceededMessage, invalidVideoMessage, MAX_FILE_SIZE_VIDEO, invalidImageMessage, imageSizeExceededMessage } from '../../components/imageType'; // Import the allowed image types
import UploadButton from '../../components/ul/UploadButton';
import FileUpload from '../../components/ul/FileUpload';
import CancelButton from '../../components/ul/CancelButton';

const UpdateStoryData = () => {
    const S_ID = useLocation().pathname.split('/')[4];
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [storyData, setStoryData] = useState({
        thembnal: '',
        image: '',
        video: '',
        adsStory: false,
        storyTime: '',
        btnName: "",
        btnUrl: ""
    });
    const [file, setFile] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [videoList, setVideoList] = useState(null);
    const [videoFile, setVideoFile] = useState(null);
    const [maxView, setMaxView] = useState(0)
    const [maxClick, setMaxClick] = useState(0);
    const [selectedLimit, setSelectedLimit] = useState("None");
    const [limitList, setLimitList] = useState([
        "View",
        "Click",
        "None"
    ])

    const [fileProcessing, setFileProcessing] = useState({
        image: false,
        video: false,
    });
    const [fileStatus, setFileStatus] = useState({
        image: null, // 'success', 'error', or null
        video: null,
    });

    useEffect(() => {
        fetchStories();
        // eslint-disable-next-line
    }, []);

    const fetchStories = async () => {
        setLoader(true);
        try {
            const response = await Calling.getStoryData(S_ID);
            if (response?.status) {
                setStoryData(response?.data);
                setVideoList(response?.data?.video ? 'Video' : 'Image');
                setMaxView(response?.data?.maxviewLimit);
                setMaxClick(response?.data?.maxclickLimit);
                setSelectedLimit(response?.data?.maxclickStatus ? "Click" : response?.data?.maxviewStatus ? "View" : "None");
                setFile(true);
            }
        } catch (error) {
            console.error(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    };

    const handleLimitChange = (e) => {
        const value = e.target.value;
        setSelectedLimit(value);

        // Reset values when changing selection
        if (value === "None") {
            setMaxView(0);
            setMaxClick(0);
        }
    };

    const handleChangeFile = (e) => {
        const { name, files, id } = e.target;
        const file = files[0];

        if (file) {
            if (name === 'image') {
                if (!imageType.includes(file.type)) {
                    setFile(null);
                    toast.error(invalidImageMessage);
                    setImageFile(null);
                    setFileProcessing(prevState => ({ ...prevState, [name]: false }));
                    setFileStatus(prevState => ({ ...prevState, [name]: 'error' }));
                    e.target.value = '';
                    return;
                }
                if (file.size > MAX_FILE_SIZE_IMAGE) {
                    setFile(null);
                    toast.error(imageSizeExceededMessage);
                    setImageFile(null);
                    setFileProcessing(prevState => ({ ...prevState, [name]: false }));
                    setFileStatus(prevState => ({ ...prevState, [name]: 'error' }));
                    e.target.value = '';
                    return;
                }
            }

            if (name === 'video') {
                if (!videoType.includes(file.type)) {
                    setFile(null);
                    toast.error(invalidVideoMessage);
                    setVideoFile(null);
                    setFileProcessing(prevState => ({ ...prevState, [name]: false }));
                    setFileStatus(prevState => ({ ...prevState, [name]: 'error' }));
                    e.target.value = '';
                    return;
                }
                if (file.size > MAX_FILE_SIZE_VIDEO) {
                    setFile(null);
                    toast.error(videoSizeExceededMessage);
                    setVideoFile(null);
                    setFileProcessing(prevState => ({ ...prevState, [name]: false }));
                    setFileStatus(prevState => ({ ...prevState, [name]: 'error' }));
                    e.target.value = '';
                    return;
                }
            }

            setFileProcessing(prevState => ({ ...prevState, [id]: true }));
            setFileStatus(prevState => ({ ...prevState, [id]: null }));

            // Simulate file processing
            setTimeout(() => {
                setFileProcessing(prevState => ({ ...prevState, [id]: false }));
                setFileStatus(prevState => ({ ...prevState, [id]: 'success' }));
            }, 1000); // Simulate a delay

            // Update file states
            if (name === 'image') {
                setFile(true);
                setImageFile(file);
            } else if (name === 'video') {
                setFile(true);
                setVideoFile(file);
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStoryData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            toast.error("Please select a valid image to upload.");
            return;
        }
        try {
            setLoader(true);
            const formData = new FormData();

            // File validation and appending to FormData
            if (imageFile) {
                formData.append('image', imageFile);
            }

            if (videoFile) {
                formData.append('video', videoFile);
            }

            // Prepare base story data
            const storyDatset = {
                storyTime: storyData?.storyTime,
                adsStory: false,
                btnName: storyData?.btnName || '',
                btnUrl: storyData?.btnUrl || '',
                status: storyData?.status
            };

            // Add limit settings if applicable
            if (selectedLimit === "View") {
                storyDatset.maxviewLimit = maxView;
                storyDatset.maxclickLimit = 0;
                storyDatset.maxviewStatus = true;
                storyDatset.maxclickStatus = false;
            } else if (selectedLimit === "Click") {
                storyDatset.maxclickLimit = maxClick;
                storyDatset.maxviewLimit = 0;
                storyDatset.maxclickStatus = true;
                storyDatset.maxviewStatus = false;
            }

            // Append final JSON data
            formData.append('insertData', JSON.stringify(storyDatset));

            formData.append('_id', JSON.stringify(S_ID));
            const response = await Calling.updateStoryData(formData);

            if (response?.status) {
                setTimeout(() => {
                    toast.success('Story updated successfully!');
                    setTimeout(() => {
                        navigate('/add/story/video');
                    }, 1000);
                }, 1);

            } else {
                toast.error(response?.message || 'Failed to update story.');
            }

        } catch (error) {
            toast.error(error.message || 'Failed to update story.');
            console.error(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    };

    const handleCancel = () => {
        navigate('/add/story/video')
    }

    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <>
                    <div className='w-full text-main-font mt-16 px-2 sm:px-3 md:ml-[4.4rem]'>
                        <h1 className="text-xl md:text-2xl font-bold mt-4 text-main-font w-auto">Story Management</h1>
                        <div className='bg-main-white rounded-xl shadow-sm mt-3'>
                            <Navbar selectState={'video'} />
                            <hr className='mt-2 bg-main-border border-[1px]' />

                            <div className='w-full p-3 sm:p-4 md:p-6'>
                                {/* Header with Toggle */}
                                <div className='flex flex-col sm:flex-row justify-between sm:items-center mb-3 gap-2'>
                                    <h2 className='text-lg md:text-xl font-bold'>Uploaded Stories</h2>
                                    <div className='flex items-center'>
                                        <label className="cursor-pointer relative inline-flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={storyData?.status}
                                                onChange={(e) => setStoryData({ ...storyData, status: !storyData?.status })}
                                                className="sr-only peer"
                                                name='storyvideo'
                                            />
                                            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-red-300 dark:peer-focus:ring-red-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-main-white after:border-main-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
                                        </label>
                                    </div>
                                </div>
                                <hr className='border-main-border' />

                                <form className='space-y-6 mt-6' onSubmit={handleSubmit}>
                                    {/* Type and Timing Section */}
                                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                        {/* Type Field */}
                                        <div>
                                            <label htmlFor='videoList' className='block text-sm font-medium text-main-font mb-1'>
                                                Type
                                            </label>
                                            <select
                                                id='videoList'
                                                name='videoList'
                                                value={videoList || ''}
                                                onChange={e => setVideoList(e.target.value)}
                                                className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                                required
                                            >
                                                <option value='Video'>Video</option>
                                                <option value='Image'>Image</option>
                                            </select>
                                        </div>

                                        {/* Timing Field */}
                                        <div>
                                            <label htmlFor='storyTime' className='block text-sm font-medium text-main-font mb-1'>
                                                Timing
                                            </label>
                                            <input
                                                id='storyTime'
                                                type='number'
                                                name='storyTime'
                                                value={storyData?.storyTime}
                                                onChange={handleChange}
                                                className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed'
                                                required
                                                min={0}
                                                disabled={videoList === 'Video'}
                                            />
                                        </div>
                                    </div>

                                    {/* View and Click Counts Section */}
                                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                        {/* View Count */}
                                        <div>
                                            <label htmlFor='view' className='block text-sm font-medium text-main-font mb-1'>
                                                View Count
                                            </label>
                                            <input
                                                id='view'
                                                type='number'
                                                name='view'
                                                value={storyData?.view}
                                                onChange={handleChange}
                                                className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent bg-gray-50 cursor-not-allowed'
                                                required
                                                min={0}
                                                disabled
                                            />
                                        </div>

                                        {/* Click Count */}
                                        <div>
                                            <label htmlFor='clickBtnCount' className='block text-sm font-medium text-main-font mb-1'>
                                                Click Count
                                            </label>
                                            <input
                                                id='clickBtnCount'
                                                type='number'
                                                name='clickBtnCount'
                                                value={storyData?.clickBtnCount}
                                                onChange={handleChange}
                                                className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent bg-gray-50 cursor-not-allowed'
                                                required
                                                min={0}
                                                disabled
                                            />
                                        </div>
                                    </div>

                                    {/* Button Name and URL Section */}
                                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                        {/* Button Name Field */}
                                        <div>
                                            <label htmlFor='btnName' className='block text-sm font-medium text-main-font mb-1'>
                                                Button Name
                                            </label>
                                            <input
                                                id='btnName'
                                                type='text'
                                                value={storyData?.btnName}
                                                name='btnName'
                                                onChange={handleChange}
                                                className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                                placeholder='Enter button name (e.g., Go Shop Now)'
                                            />
                                        </div>

                                        {/* Button URL Field */}
                                        <div>
                                            <label htmlFor='btnUrl' className='block text-sm font-medium text-main-font mb-1'>
                                                Button URL
                                            </label>
                                            <input
                                                id='btnUrl'
                                                type='url'
                                                value={storyData?.btnUrl}
                                                name='btnUrl'
                                                onChange={handleChange}
                                                className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                                placeholder='Enter button URL'
                                            />
                                        </div>
                                    </div>

                                    {/* Thumbnail Image Section */}
                                    <div>
                                        <label className='block text-sm font-medium text-main-font mb-1'>
                                            Thumbnail
                                        </label>
                                        {storyData?.thembnal && (
                                            <div className="mb-2">
                                                <img
                                                    src={storyData?.thembnal}
                                                    alt="Thumbnail Preview"
                                                    className="w-32 h-32 object-cover rounded border border-gray-200"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {/* Video or Image Upload Section */}
                                    {videoList === 'Video' ? (
                                        <div>
                                            <label className='block text-sm font-medium text-main-font mb-1'>
                                                Video
                                            </label>
                                            {storyData?.video && (
                                                <div className="mb-3">
                                                    <video
                                                        src={storyData?.video}
                                                        className="w-full max-w-md h-auto rounded border border-gray-200"
                                                        controls
                                                    />
                                                </div>
                                            )}
                                            <div className='relative max-w-md'>
                                                <FileUpload
                                                    id="video"
                                                    name='video'
                                                    accept="video/mp4"
                                                    onChange={handleChangeFile}
                                                    required={false}
                                                />
                                                <div className='absolute top-2 right-2'>
                                                    {fileProcessing['video'] && <div className='loader'></div>}
                                                    {fileStatus['video'] === 'error' && <span className='text-red-500 text-xl'>✘</span>}
                                                    {fileStatus['video'] === 'success' && <span className='text-green-500 text-xl'>✓</span>}
                                                </div>
                                            </div>
                                            <p className={`text-xs mt-1 ${fileStatus['video'] === 'error' ? 'text-main-delete' : 'text-main-subfont'}`}>
                                                Only MP4 files are allowed
                                            </p>
                                        </div>
                                    ) : (
                                        <div>
                                            <label className='block text-sm font-medium text-main-font mb-1'>
                                                Image
                                            </label>
                                            {storyData?.image && (
                                                <div className="mb-3">
                                                    <img
                                                        src={storyData?.image}
                                                        alt="Image Preview"
                                                        className="w-full max-w-md h-auto object-cover rounded border border-gray-200"
                                                    />
                                                </div>
                                            )}
                                            <div className='relative max-w-md'>
                                                <FileUpload
                                                    id="image"
                                                    name='image'
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    onChange={handleChangeFile}
                                                    required={false}
                                                />
                                                <div className='absolute top-2 right-2'>
                                                    {fileProcessing['image'] && <div className='loader'></div>}
                                                    {fileStatus['image'] === 'error' && <span className='text-red-500 text-xl'>✘</span>}
                                                    {fileStatus['image'] === 'success' && <span className='text-green-500 text-xl'>✓</span>}
                                                </div>
                                            </div>
                                            <p className={`text-xs mt-1 ${fileStatus['image'] === 'error' ? 'text-main-delete' : 'text-main-subfont'}`}>
                                                Only PNG, JPG, JPEG files are allowed
                                            </p>
                                        </div>
                                    )}

                                    {/* Limit Settings Section */}
                                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                                        <h3 className="text-lg font-medium text-gray-900 mb-4">Limit Settings</h3>

                                        <div className="space-y-4">
                                            <div>
                                                <label htmlFor="limit-type" className="block text-sm font-medium text-gray-700 mb-1">
                                                    Limit Type
                                                </label>
                                                <select
                                                    id="limit-type"
                                                    value={selectedLimit}
                                                    onChange={handleLimitChange}
                                                    className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                >
                                                    {limitList.map((limit) => (
                                                        <option key={limit} value={limit}>
                                                            {limit}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {selectedLimit === "View" && (
                                                <div>
                                                    <label htmlFor="max-view" className="block text-sm font-medium text-gray-700 mb-1">
                                                        Maximum Views
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="max-view"
                                                        value={maxView}
                                                        onChange={(e) => setMaxView(parseInt(e.target.value) || 0)}
                                                        min="0"
                                                        className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                        placeholder="Enter maximum view count"
                                                    />
                                                </div>
                                            )}

                                            {selectedLimit === "Click" && (
                                                <div>
                                                    <label htmlFor="max-click" className="block text-sm font-medium text-gray-700 mb-1">
                                                        Maximum Clicks
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="max-click"
                                                        value={maxClick}
                                                        onChange={(e) => setMaxClick(parseInt(e.target.value) || 0)}
                                                        min="0"
                                                        className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                        placeholder="Enter maximum click count"
                                                    />
                                                </div>
                                            )}

                                            {selectedLimit !== "None" && (
                                                <p className="text-sm text-gray-500 italic">
                                                    {selectedLimit === "View"
                                                        ? "Product will be limited by the number of times it's viewed."
                                                        : "Product will be limited by the number of times it's clicked."}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Form Buttons */}
                                    <div className='flex flex-col sm:flex-row gap-3 pt-4'>
                                        <UploadButton className='w-full sm:w-auto inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500' />
                                        <CancelButton className='w-full sm:w-auto inline-flex justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500' onClick={handleCancel} />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </>
            )
            }
        </>
    );
};

export default UpdateStoryData;
